/* eslint-disable ember/no-computed-properties-in-native-classes */
import Post from './post';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import {
  hasMany,
  belongsTo,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import type Event from '@linc-technologies/linced-common/models/events/event';
import type Goal from 'linced-app/models/goals/goal';
import type Media from 'linced-app/models/media';
import type Comment from 'linced-app/models/posts/comment';
import type Reaction from 'linced-app/models/posts/reaction';

// Proto: posts.Post.
export default class Communitynotice extends Post {
  declare [Type]: 'posts/communitynotice';

  postType = PostTypes.COMMUNITY_NOTICE;

  @hasMany('posts/comment', { async: true, inverse: 'communityNoticeId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse communityNoticeId).
  declare comments: AsyncHasMany<Comment>;

  @hasMany('posts/reaction', { async: true, inverse: 'communityNoticeId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse communityNoticeId).
  declare reactions: AsyncHasMany<Reaction>;

  @hasMany('media', { async: true, inverse: 'communityNoticeId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse communityNoticeId).
  declare mediaIds: AsyncHasMany<Media>;

  @belongsTo('events/event', { async: true, inverse: 'communityNotices' })
  declare eventId: AsyncBelongsTo<Event>;

  @alias('eventId')
  declare event: AsyncBelongsTo<Event>;

  // Don't trigger the Person reloads which the base Post model does.
  @belongsTo('goals/goal', { async: true, inverse: null })
  declare topicId: AsyncBelongsTo<Goal>;

  @alias('topicId')
  declare topic: AsyncBelongsTo<Goal>;

  reloadPersonOnSave = false;
}
